import React from 'react';
import { NavLink } from 'react-router-dom';

export default function PageNavigation() {
    return (
        <ul className="navigation-tabs__list">
            {/* <li className="navigation-tabs__list-item">
                <NavLink
                    to="general"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    General
                </NavLink>
            </li> */}
            <li className="navigation-tabs__list-item">
                <NavLink
                    to="email"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    Email
                </NavLink>
            </li>
            <li className="navigation-tabs__list-item">
                <NavLink
                    to="sms"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    SMS
                </NavLink>
            </li>
            <li className="navigation-tabs__list-item">
                <NavLink
                    to="slack"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    Slack
                </NavLink>
            </li>
            <li className="navigation-tabs__list-item">
                <NavLink
                    to="push"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    Push
                </NavLink>
            </li>
        </ul>
    );
}
